import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=42df26ab&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=ts&"
export * from "./ContactInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=42df26ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42df26ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
